import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import icon from "../images/Icons/testimonial.png";
import placeImage from "../images/Icons/user.png";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTestimonial } from "../redux/slice/testimonial";

export default function Testimonial() {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1921 },
      items: 4,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 1920, min: 1025 },
      items: 3,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const dispatch = useDispatch();
  const { testimonialData, isError } = useSelector(
    (state) => state.testimonial
  );
  useEffect(() => {
    if (!isError) {
      dispatch(fetchTestimonial());
    }
  }, [dispatch, isError]);

  const imageOnError = (event) => {
    event.currentTarget.src = placeImage;
  };

  return (
    <>
      <div className="container-fluid">
        <div className="showcase-product mrty1">
          <div className="row-hd-txt">
            <div className="row-hd-txt-left">
              <img src={icon} alt="icon" />
              <h5>What Our Buyers Say</h5>
            </div>
          </div>
          <div className="testimonials-row">
            <Carousel
              responsive={responsive}
              swipeable={true}
              draggable={true}
              infinite={true}
              showDots={false}
              autoPlay={true}
              autoPlaySpeed={4000}
              removeArrowOnDeviceType={["mobile", "tablet", "desktop"]}
            >
              {testimonialData.map((data, index) => {
                return (
                  <div className="testimonial-item" key={index}>
                    <i className="bi bi-quote mb-3"></i>
                    <p>"{data.message}"</p>
                    <div className="d-flex align-items-center">
                      <img
                        className="img-fluid flex-shrink-0 rounded-circle"
                        src={data.image}
                        onError={imageOnError}
                        alt=""
                      />
                      <div className="ps-3">
                        <h6 className="mb-0">{data.name}</h6>
                        <small>{data.designation}</small>
                      </div>
                    </div>
                    <div className="abst-icon">
                      <i className="bi bi-quote"></i>
                    </div>
                  </div>
                );
              })}
            </Carousel>
          </div>
        </div>
      </div>
    </>
  );
}
